import logo from './logo.svg';
import './App.css';
import Weatherbody from './Component/WeatherBody';
import WeatherSetting from './Component/WeatherSetting';

function App() {
  return (
    <div className="App">
      <header className="App-header">
       <WeatherSetting/>
      </header>
    </div>
  );
}

export default App;
